export const createSelectCallback = (styles) => ({ isActive }) => isActive ?  styles.selected : "";

export default [
    {to: "/login", component: "/login", text: "登陆"},
    {to: "/backend/login", component: "/login", text: "登陆"},
    {to: "/agent/login", component: "/login", text: "登陆"},
    {to: "/register", component: "/register", text: "登陆"}
]

export const USER_DASHBOARD_LINK  = "/app/dashboard";
export const ADMIN_DASHBOARD_LINK  = "/backend/dashboard";
